'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Hamburger = void 0;
const $ = require("jquery");
class Hamburger {
    constructor() {
        this.scrollY = 0;
        this.preventScroll = (e) => {
            e.preventDefault();
        };
        console.log('test');
        // ハンバーガーボタン押下
        $('.trigHamburger').on('click', (e) => {
            const $btn = $(e.currentTarget);
            const isActive = $btn.attr('data-is-active') === 'true';
            console.log('o');
            if (!isActive) {
                this.openMenu($btn);
            }
            else {
                this.closeMenu($btn);
            }
        });
        // 閉じるボタン押下
        $('.trigCloseMenu').on('click', () => {
            this.closeMenu($('.trigHamburger'));
        });
        // オーバーレイクリックで閉じる
        $('.bulletOverlay').on('click', () => {
            this.closeMenu($('.trigHamburger'));
        });
        // bfcache 復元時にメニューをリセット
        window.addEventListener('pageshow', (event) => {
            if (event.persisted)
                this.resetMenu();
        });
        this.resetMenu();
    }
    openMenu($btn) {
        $btn.attr('data-is-active', 'true');
        this.lockScroll();
        $('.bulletOverlay').fadeIn(200);
        $('.bulletMenu').fadeIn(200);
    }
    closeMenu($btn) {
        $btn.attr('data-is-active', 'false');
        $('.bulletOverlay').fadeOut(200);
        $('.bulletMenu').fadeOut(200, () => {
            this.unlockScroll();
        });
    }
    lockScroll() {
        this.scrollY = window.scrollY || window.pageYOffset || 0;
        const body = document.body;
        body.style.position = 'fixed';
        body.style.top = `-${this.scrollY}px`;
        body.style.left = '0';
        body.style.right = '0';
        body.style.width = '100%';
        // iOS での背景慣性スクロール抑止
        $('.bulletOverlay').on('touchmove', this.preventScroll);
    }
    unlockScroll() {
        const body = document.body;
        body.style.position = '';
        body.style.top = '';
        body.style.left = '';
        body.style.right = '';
        body.style.width = '';
        window.scrollTo(0, this.scrollY);
        $('.bulletOverlay').off('touchmove', this.preventScroll);
    }
    resetMenu() {
        $('.trigHamburger').attr('data-is-active', 'false');
        $('.bulletOverlay').hide();
        $('.bulletMenu').hide();
        this.unlockScroll();
    }
}
exports.Hamburger = Hamburger;
exports.default = Hamburger;
